import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const PropsTableBasePropRows = makeShortcode("PropsTableBasePropRows");
const Link = makeShortcode("Link");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {Flash} from '@primer/react'
`}</code></pre>
    <p>{`The Flash component informs users of successful or pending actions.`}</p>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <Flash>Default Flash</Flash>
  <Flash variant="success">Success Flash</Flash>
  <Flash variant="warning">Warning Flash</Flash>
  <Flash variant="danger">Danger Flash</Flash>
</>
`}</code></pre>
    <h3>{`With an icon`}</h3>
    <p>{`Flash components with icons inside of them will automatically set the correct color for the icon depending on the type of Flash, as well as applying the correct right margin.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Flash variant="success">
  <StyledOcticon icon={CheckIcon} />
  Success!
</Flash>
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`Flash`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="full" type="boolean" defaultValue="false" description="Creates a full width Flash component" mdxType="PropsTableRow" />
  <PropsTableRow name="variant" type="'default' | 'success' | 'warning' | 'danger'" defaultValue="'default'" description="Sets the background color and border" mdxType="PropsTableRow" />
  <PropsTableBasePropRows elementType="div" isPolymorphic refType="HTMLDivElement" passthroughPropsLink={<Link href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element/div#Attributes" mdxType="Link">MDN</Link>} mdxType="PropsTableBasePropRows" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: false,
      fullTestCoverage: false,
      usedInProduction: false,
      usageExamplesDocumented: true,
      hasStorybookStories: false,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      